import React from 'react'

const AccountingReceipt = () => {
  return (
    <div>AccountingReceipt</div>
  )
}

export default AccountingReceipt